<div
  class="flex h-16 shrink-0 items-center justify-between border-b border-default px-5"
  [class.justify-center]="collapsed()"
  [class.px-0]="collapsed()"
>
  @if (collapsed()) {
    <span class="font-display text-lg font-semibold tracking-tight text-brand">FTG</span>
  } @else {
    <span class="font-display text-lg font-semibold tracking-tight text-primary">Find The Gap</span>
  }
  @if (isMobile() && !collapsed()) {
    <button
      type="button"
      class="flex h-9 w-9 items-center justify-center rounded-md text-tertiary hover:bg-hover hover:text-primary"
      (click)="closeRequested.emit()"
      aria-label="Cerrar menú"
    >
      <mat-icon svgIcon="x" class="!h-5 !w-5"></mat-icon>
    </button>
  }
</div>

<nav class="min-h-0 flex-1 overflow-y-auto px-2 py-3" aria-label="Navegación principal">
  @for (section of visibleSections(); track section.id) {
    <div class="mb-4">
      @if (!collapsed()) {
        <div class="px-3 pb-1.5 text-overline font-semibold tracking-wide text-tertiary uppercase">
          {{ section.title }}
        </div>
      }
      <ul class="m-0 flex list-none flex-col gap-0.5 p-0">
        @for (item of section.items; track item.id) {
          <li>
            @if (item.disabled) {
              <span
                class="flex cursor-not-allowed items-center gap-3 rounded-md px-3 py-2 text-body-strong text-disabled opacity-50"
                [class.justify-center]="collapsed()"
                [matTooltip]="item.label + ' (próximamente)'"
                matTooltipPosition="right"
              >
                <mat-icon [svgIcon]="item.icon" class="!h-5 !w-5 shrink-0"></mat-icon>
                @if (!collapsed()) {
                  <span class="truncate">{{ item.label }}</span>
                }
              </span>
            } @else {
              <a
                [routerLink]="item.route"
                routerLinkActive="bg-selected text-brand font-medium"
                [routerLinkActiveOptions]="{ exact: item.route === '/dashboard' }"
                class="flex items-center gap-3 rounded-md px-3 py-2 text-body-strong text-secondary no-underline transition-colors duration-[120ms] hover:bg-hover hover:text-primary"
                [class.justify-center]="collapsed()"
                [matTooltip]="collapsed() ? item.label : ''"
                matTooltipPosition="right"
              >
                <mat-icon [svgIcon]="item.icon" class="!h-5 !w-5 shrink-0"></mat-icon>
                @if (!collapsed()) {
                  <span class="truncate">{{ item.label }}</span>
                  @if (item.badge && item.badge() > 0) {
                    <span
                      class="ml-auto rounded-full bg-gold-100 px-1.5 py-0.5 text-caption font-semibold text-gold-700 dark:bg-gold-300/20 dark:text-gold-300"
                    >
                      {{ item.badge() }}
                    </span>
                  }
                }
              </a>
            }
          </li>
        }
      </ul>
    </div>
  }
</nav>

<div class="border-t border-default p-2">
  <button
    type="button"
    class="flex w-full items-center gap-2 rounded-md p-2 text-left hover:bg-hover"
    [class.justify-center]="collapsed()"
    [matMenuTriggerFor]="userMenu"
    aria-label="Menú de usuario"
  >
    @if (tokenService.user(); as user) {
      <app-avatar [name]="user.fullName" size="sm" />
      @if (!collapsed()) {
        <span class="min-w-0 flex-1">
          <span class="block truncate text-body-strong text-primary">{{ user.fullName }}</span>
          <span class="block truncate text-caption text-tertiary">{{ user.email }}</span>
        </span>
        <mat-icon svgIcon="chevron-right" class="!h-4 !w-4 text-tertiary"></mat-icon>
      }
    }
  </button>

  <mat-menu #userMenu="matMenu">
    <button mat-menu-item routerLink="/account/profile">
      <mat-icon svgIcon="user"></mat-icon>
      <span>Mi perfil</span>
    </button>
    <button mat-menu-item routerLink="/account/sessions">
      <mat-icon svgIcon="smartphone"></mat-icon>
      <span>Mis sesiones</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="themeMenu">
      <mat-icon svgIcon="sun"></mat-icon>
      <span>Tema: {{ themeModeLabels[themeService.mode()] }}</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon svgIcon="log-out"></mat-icon>
      <span>Cerrar sesión</span>
    </button>
  </mat-menu>

  <mat-menu #themeMenu="matMenu">
    <button mat-menu-item (click)="setThemeMode('light')">
      <mat-icon svgIcon="sun"></mat-icon>
      <span>Claro</span>
    </button>
    <button mat-menu-item (click)="setThemeMode('dark')">
      <mat-icon svgIcon="moon"></mat-icon>
      <span>Oscuro</span>
    </button>
    <button mat-menu-item (click)="setThemeMode('auto')">
      <mat-icon svgIcon="monitor"></mat-icon>
      <span>Automático</span>
    </button>
  </mat-menu>
</div>

<button
  type="button"
  class="hidden shrink-0 items-center justify-center border-t border-default py-2 text-tertiary hover:bg-hover hover:text-primary lg:flex"
  (click)="toggleCollapsed()"
  [attr.aria-label]="collapsed() ? 'Expandir menú' : 'Colapsar menú'"
>
  <mat-icon
    [svgIcon]="collapsed() ? 'panel-left' : 'panel-left-close'"
    class="!h-5 !w-5"
  ></mat-icon>
</button>
